import classNames from 'classnames';
import Button from "@/components/Button/Button";
import React, { useCallback, useState, useTransition } from "react";
import IconShare from "@/lib/assets/images/share.svg";
import { useShareDataStore } from "@/lib/stores/post";
import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import { BUTTON_VARIANTS, SIZES } from "@/lib/utils/constants";

const ShareDropdown = dynamic(() => import('@/components/ShareDropdown/ShareDropdown').then((mod) => mod.default), { ssr: false });

export default function PostShare(
  {
    className,
    variant = 'default',
    size = 'default',
    shareDropdownArrowPosition = 'start'
  }
) {
  const [, startTransition] = useTransition();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const shareData = useShareDataStore();

  const handleTriggerClick = () => {
    // Check for SSR compatibility
    if (typeof window === 'undefined') return;
    
    const isMobile = window.innerWidth < 768; // 768px is md breakpoint based on context
    if (isMobile && typeof navigator !== 'undefined' && 'share' in navigator) {
      navigator.share(shareData).then(() => {
      }).catch(err => {
        // console.log(err);
      });
    } else {
      startTransition(() => {
        setDropdownVisible(!dropdownVisible);
      });
    }
  };

  const handleCloseDropdown = useCallback(() => {
    startTransition(() => {
      setDropdownVisible(false);
    });
  }, []);

  return (
    <>
      <Button
        className={classNames(
          'whitespace-nowrap',
          { 'mom-active-border': dropdownVisible },
          className
        )}
        size={size}
        variant={variant}
        onClick={handleTriggerClick}
        aria-label={'Share'}
      ><IconShare />Share</Button>

      {dropdownVisible && (
        <ShareDropdown closeDropdown={handleCloseDropdown} align={shareDropdownArrowPosition} />
      )}
    </>
  );
}

PostShare.propTypes = {
  variant: PropTypes.oneOf(BUTTON_VARIANTS),
  size: PropTypes.oneOf(SIZES),
  className: PropTypes.string,
};
